// extracted by mini-css-extract-plugin
module.exports = {"hideMoreButton":"jut__MoreButton__hideMoreButton"};